import { useCallback } from 'react';

import { useDeviceType } from '@cian/ui-kit';

import { NewUserBonusBanner } from 'shared/components/NewUserBonusBanner';
import { BUTTON_TEXT } from 'shared/constants/tracking';
import { useAppDispatch, useLandingTracking } from 'shared/hooks';
import { setVisible } from 'shared/slices';

export const NewUserBonusBannerContainer: React.FC = () => {
  const device = useDeviceType();

  const dispatch = useAppDispatch();
  const { trackButtonClick } = useLandingTracking();

  const isPhone = device === 'phone';

  const btnSize = isPhone ? 'M' : 'L';

  const themeType = isPhone ? 'light' : 'colored';

  const handleModalOpen = useCallback(() => {
    trackButtonClick(BUTTON_TEXT.SUBMIT_AD);
    dispatch(setVisible(true));
  }, [dispatch, trackButtonClick]);

  return (
    <NewUserBonusBanner
      device={device}
      btnProps={{ size: btnSize, color: 'fill_primary', onClick: handleModalOpen }}
      themeType={themeType}
    />
  );
};
